import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import IntegrationService from "@mapmycustomers/shared/enum/integrations/IntegrationService";
import IntegrationSyncDirection from "@mapmycustomers/shared/enum/integrations/IntegrationSyncDirection";

import logoCircle from "@app/assets/logoCircle.svg";
import {
  getIntegrationDirectionIcon,
  getIntegrationIcon,
} from "@app/scene/settings/component/Integrations/utils/iconGetters";

import styles from "./SyncDirection.module.scss";

interface Props {
  direction?: IntegrationSyncDirection;
  type: IntegrationService;
}

const SyncDirection: React.FC<Props> = ({
  direction = IntegrationSyncDirection.SERVICE_TO_MMC,
  type,
}) => (
  <div className={styles.container}>
    <img alt="type" className={styles.image} src={getIntegrationIcon(type, true)} />
    <FontAwesomeIcon
      className={styles.icon}
      icon={getIntegrationDirectionIcon(direction)}
      size="2x"
    />
    <img alt="logoCircle" className={styles.image} src={logoCircle} />
  </div>
);

export default SyncDirection;
